import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { createApiClient } from "../api/apiClient";
import { setRoles } from "../store/slices/appDataSlice";
import { logger } from "../utils/logger";

/**
 * Fetches fresh roles from the server every time the component mounts,
 * ensuring any recent admin changes are reflected in dropdowns/UI.
 *
 * Fetches only Observation roles scoped to the current location.
 * Location context (locationTypes, organizationTypes, threePlStatuses) and
 * statuses: 'Enabled' are injected automatically by the API interceptor in
 * apiClient.ts based on Redux selectedLocation — they are not passed explicitly.
 */
export const useRefreshRoles = (): void => {
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const api = createApiClient();
        const roleParams: Record<string, any> = {
          page: 0,
          size: 9999,
          statuses: "Enabled",
          availableIns: "Observations",
        };

        const rolesRaw = await api.get("/admin/role-management/roles", {
          params: roleParams,
        });
        const rolesContent = Array.isArray(rolesRaw.data)
          ? rolesRaw.data
          : rolesRaw.data?.content ?? [];
        const normalised = rolesContent.map((r: any) => ({
          ROLE_ID: r.id ?? r.name ?? "",
          ROLE_NAME: r.name ?? "",
        }));
        dispatch(setRoles(normalised));
      } catch (err) {
        logger.error("Error refreshing roles:", err);
      }
    };

    fetchRoles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
